import Vue from "vue";
export const navigationBus = new Vue();
